<template>
    <div>
        <label> {{ label }} </label>
        <select-field
            :value.sync="selectValue"
            :label="label"
            :placeholder="placeholder"
            :items="items"
            :error.sync="error"
            :errorMsg.sync="errorMsg"
        />
    </div>
</template>
<script>
import SelectField from "../atoms/SelectField.vue";
export default {
    components: { SelectField },
    props: {
        handle: String,
        label: String,
        value: [String,Number],
        items: Array,
        placeholder: String,
        readonry: Boolean,
        error: Boolean,
        errorMsg: Array,
    },
    computed: {
        selectValue: {
            get: function () {
                return this.value;
            },
            set: function (value) {
                this.$emit("update:value", value);
            },
        },
    },
};
</script>